import { set } from "@/utils/tools"

export enum ENV {
    DEV = "DEV",
    PROD = "PROD",
}

enum KEY {
    DEV = "30dZqViYwVkewRpa",
    PROD = "6TgrBnM3FwYVY5Vu",
}

enum KEY_AUTH {
    DEV = "30dZqViYwVkewRpa",
    PROD = "6TgrBnM3FwYVY5Vu",
}

export enum ENV_HOST {
    DEV = "https://mpr-dev-gw.cocokobe.com/",
    PROD = "https://xxapiws.51colopay.cn/",
}

interface envKeys {
    crypt_key: KEY
    crypt_key_auth: KEY_AUTH
    open_crypt: boolean
    ApiHost: string
    ApiUrl: string
}

type Env = Record<ENV, envKeys>
export const GLOBAL_ENV: Env = {
    [ENV.DEV]: {
        crypt_key: KEY.DEV,
        crypt_key_auth: KEY_AUTH.DEV,
        open_crypt: false,
        ApiHost: `${ENV_HOST.DEV}`,
        ApiUrl: `${ENV_HOST.DEV}mpr-manage`,
    },
    [ENV.PROD]: {
        crypt_key: KEY.PROD,
        crypt_key_auth: KEY_AUTH.PROD,
        open_crypt: true,
        ApiHost: `${ENV_HOST.PROD}`,
        ApiUrl: `${ENV_HOST.PROD}mpr-manage`,
    },
}

export const getEnvConfig = () => {
    let currentEnv = process.env.REACT_APP_ENV as ENV
    let envName = currentEnv || ENV.DEV

    const envConfig = GLOBAL_ENV[envName]
    if (
        window.location.host.includes("xsite-admin-prd.cocokobe.com") ||
        window.location.host.includes("xsite-admin-prd-2wsx.cocokobe.com")
    ) {
        set(envConfig, "ApiHost", "https://xxapiws.51colopay.cn/")
        set(envConfig, "ApiUrl", "https://xxapiws.51colopay.cn/mpr-manage")
    }
    if (
        window.location.host.includes("b9-admin.sxweb99.com") ||
        window.location.host.includes("b9-admin-2wsx.sxweb99.com")
    ) {
        set(envConfig, "ApiHost", "https://b9apiws.51colopay.cn/")
        set(envConfig, "ApiUrl", "https://b9apiws.51colopay.cn/mpr-manage")
    }
    if (
        window.location.host.includes("7v-admin.sxweb99.com") ||
        window.location.host.includes("7v-admin-2wsx.sxweb99.com")
    ) {
        set(envConfig, "ApiHost", "https://7vapiws.51colopay.cn/")
        set(envConfig, "ApiUrl", "https://7vapiws.51colopay.cn/mpr-manage")
    }
    if (
        window.location.host.includes("3p-admin.sxweb99.com") ||
        window.location.host.includes("3p-admin-2wsx.sxweb99.com")
    ) {
        set(envConfig, "ApiHost", "https://3papiws.51colopay.cn/")
        set(envConfig, "ApiUrl", "https://3papiws.51colopay.cn/mpr-manage")
    }
    if (
        window.location.host.includes("5v-admin.sxweb99.com") ||
        window.location.host.includes("5v-admin-2wsx.sxweb99.com")
    ) {
        set(envConfig, "ApiHost", "https://5vapiws.51colopay.cn/")
        set(envConfig, "ApiUrl", "https://5vapiws.51colopay.cn/mpr-manage")
    }
    if (
        window.location.host.includes("7c-admin.sxweb99.com") ||
        window.location.host.includes("7c-admin-2wsx.sxweb99.com")
    ) {
        set(envConfig, "ApiHost", "https://7capiws.51colopay.cn/")
        set(envConfig, "ApiUrl", "https://7capiws.51colopay.cn/mpr-manage")
    }
    if (
        window.location.host.includes("5d-admin.sxweb99.com") ||
        window.location.host.includes("5d-admin-2wsx.sxweb99.com")
    ) {
        set(envConfig, "ApiHost", "https://5dapiws.51colopay.cn/")
        set(envConfig, "ApiUrl", "https://5dapiws.51colopay.cn/mpr-manage")
    }
    if (
        window.location.host.includes("6v-admin.sxweb99.com") ||
        window.location.host.includes("6v-admin-2wsx.sxweb99.com")
    ) {
        set(envConfig, "ApiHost", "https://6vapiws.51colopay.cn/")
        set(envConfig, "ApiUrl", "https://6vapiws.51colopay.cn/mpr-manage")
    }
    return envConfig
}
